// DOC-DEPS: LLM.md -> docs/ACTIVITY_LEXICON.md
//
// Italian activity lexicon.
// Extracted from liveInputRules.it.ts.

import type { ActivityLexicon } from './types.js';

export const itActivityLexicon: ActivityLexicon = {
  strongPhrases: [
    'lavoro', 'lavorare', 'lavorando', 'ho lavorato',
    'sto lavorando',
    'studio', 'studiare', 'studiando', 'ho studiato',
    'ripasso', 'ripassando',
    'riunione', 'meeting', 'standup',
    'riunione con',
    'riunione di',
    'riunione per',
    'correndo', 'ho corso', 'corsa',
    'camminando', 'camminata', 'passeggiata',
    'cammino', 'camminare',
    'nuoto', 'nuotando',
    'nuotare',
    'allenamento', 'palestra', 'fitness',
    'yoga', 'pilates', 'stretching',
    'meditazione', 'meditando',
    'pranzo', 'cena', 'colazione', 'pasto',
    'bere acqua', 'bevo acqua', 'idratarmi',
    'bere te', 'preparare il te', 'fare il caffe', 'preparare il caffe',
    'riempire la borraccia', 'rabboccare la borraccia',
    'bollire l\'acqua', 'ho bollito l\'acqua',
    'fare da mangiare', 'preparare pranzo', 'preparare cena',
    'cuocere il riso', 'cucinare il riso', 'lavare il riso',
    'preparare i pasti', 'meal prep',
    'fare la zuppa', 'fare il porridge', 'cucinare la pasta', 'preparare gli ingredienti',
    'tagliare le verdure', 'lavare le verdure',
    'fare la spesa', 'comprare verdura', 'comprare verdure', 'comprare frutta', 'andare al mercato',
    'comprare latte', 'comprare pane', 'comprare uova', 'fare scorta', 'rifornire la dispensa',
    'spesa', 'supermercato', 'grocery',
    'spesa alimentare',
    'lavatrice', 'piatti', 'pulisco', 'pulire', 'pulizie',
    'fare il bucato', 'stendere i panni', 'piegare i vestiti',
    'riordinare la stanza', 'rifare il letto', 'cambiare le lenzuola',
    'passare l\'aspirapolvere', 'lavare il pavimento',
    'lavare i piatti', 'cucinare', 'sto cucinando', 'immondizia', 'buttare la spazzatura',
    'svuotare la spazzatura', 'portare fuori la spazzatura',
    'ho comprato',
    'pendolare', 'pendolando', 'metro', 'autobus', 'treno', 'guida', 'guidando',
    'lettura', 'leggere', 'leggendo', 'leggo', 'ho letto',
    'giornale', 'notizie', 'articolo', 'articoli',
    'scrivendo', 'scrivere', 'scrivo', 'ho scritto',
    'diario', 'scrivo diario', 'sto scrivendo diario',
    'prendo appunti', 'sto prendendo appunti',
    'chiamata', 'telefonata', 'videochiamata',
    'chatto', 'chattare', 'chiacchiero', 'chiacchierare',
    'uscita', 'uscire', 'uscendo',
    'incontro', 'incontrare', 'incontrando',
    'appuntamento', 'festa', 'karaoke',
    'gioco da tavolo', 'giochi da tavolo',
    'bar', 'caffè', 'spuntino',
    'codice', 'programmazione', 'debug', 'debuggando',
    'revisiono', 'revisionare', 'revisionando',
    'rispondo', 'rispondere', 'rispondendo',
    'aggiorno', 'aggiornare', 'aggiornando',
    'preparo', 'preparare', 'preparando',
    'rilascio', 'rilasciato', 'pubblico', 'pubblicato', 'inviare', 'inviando', 'inviato',
    'email', 'mail', 'presentazione', 'slide', 'roadmap', 'report', 'documento', 'ticket',
    'calcio', 'basket', 'pallavolo', 'tennis', 'badminton',
    'escursione', 'trekking', 'bici', 'bicicletta', 'pedalare', 'pedalando',
    'yoga', 'stretch',
    'videogioco', 'videogiochi', 'giocando', 'gioco',
    'film', 'serie', 'streaming',
    'mostra', 'museo',
    'anime', 'manga', 'romanzo', 'libro',
    'musica', 'canzone', 'concerto',
    'podcast', 'livestream', 'youtube',
    'visita medica', 'dentista',
    'pagare bollette', 'pagando bollette',
    'finanza aziendale', 'statistica',
    'allenandomi', 'palestra',
    // sport e movimento extra
    'mi alleno', 'faccio sport', 'faccio ginnastica',
    'faccio jogging', 'faccio footing', 'faccio una corsa',
    'sollevo pesi', 'sollevamento pesi',
    'squat', 'flessioni', 'addominali', 'piegamenti',
    'arrampicata', 'arrampicandomi', 'mi arrampico',
    'sci', 'sciare', 'scio', 'ho sciato',
    'snowboard',
    'surf', 'surfing', 'ho fatto surf',
    'pattinaggio', 'pattino', 'ho pattinato',
    'golf', 'bowling',
    'boxe', 'box', 'fare boxe',
    'kickboxing', 'arti marziali', 'judo', 'karate',
    'maratona', 'mezzamaratona', 'gara', 'torneo',
    'partita',
    // creative & hobby
    'diario', 'scrivo nel diario', 'ho scritto nel diario',
    'disegno', 'disegnare', 'ho disegnato',
    'dipingo', 'dipingere', 'ho dipinto',
    'schizzo', 'fare degli schizzi',
    'suono', 'suonare', 'ho suonato',
    'canto', 'cantare', 'ho cantato',
    'ballo', 'ballare', 'ho ballato',
    'cucito', 'cucire', 'maglieria', 'fare la maglia',
    'giardinaggio', 'faccio giardinaggio',
    'fotografia', 'fotografo', 'ho fotografato',
    'ceramica', 'pittura', 'artigianato',
    // professional extras
    'brainstorming', 'sessione di brainstorming',
    'progettazione', 'progetto',
    'prototipo', 'prototipazione',
    'colloquio', 'colloquio di lavoro',
    'networking', 'fare networking',
    'freelance', 'lavoro in proprio',
    'tirocinio', 'stage',
    'ricerca', 'sto facendo ricerca',
    // wellness / mind
    'respirazione', 'esercizi di respirazione', 'breathwork',
    'terapia', 'sessione di terapia', 'psicologo', 'psicologa',
    'consulenza', 'coaching',
    'digiuno', 'digiuno intermittente',
    // travel / spostamenti
    'viaggio', 'viaggiando', 'in viaggio',
    'ho viaggiato', 'sono in viaggio',
    'parto', 'sono partito', 'sono partita',
    'sono arrivato', 'sono arrivata',
    'sono tornato', 'sono tornata',
    'aereo', 'volo', 'treno', 'autobus',
    'valigia', 'sto facendo le valigie', 'ho fatto le valigie',
    'gita', 'escursione', 'gita fuori porta',
    // social / volontariato
    'volontariato', 'faccio volontariato', 'ho fatto volontariato',
    'donazione', 'ho donato',
    'ripetizioni', 'do ripetizioni', 'lezioni private',
    // health appointments
    'visita', 'visita di controllo', 'analisi', 'esami del sangue',
    'fisioterapia', 'fisioterapista',
    'farmacia', 'ho preso le medicine',
    // Query / modifica / invio / autenticazione / account
    'cercare log', 'cercare dati', 'cercare ordine', 'tracciare pacco', 'filtrare risultati', 'affinare ricerca',
    'modificare configurazione', 'modificare documento', 'aggiornare profilo', 'correggere testo', 'modificare', 'sto modificando',
    'pagamento', 'fare pagamento', 'effettuare pagamento', 'pagare fattura', 'ho pagato fattura', 'bonifico', 'fare bonifico', 'versamento', 'saldare conto',
    'controllare ordine', 'verificare ordine', 'controllare fattura', 'verificare fattura', 'riconciliare conti', 'riconciliazione', 'ricontrollare dati',
    'inviare ticket', 'inviare richiesta', 'inviare pr', 'inviare per revisione',
    'verificare identita', 'verifica identita', 'autenticazione a due fattori',
    'fare accesso', 'disconnettersi', 'reimpostare password', 'associare numero di telefono', 'scollegare dispositivo',
    'caricare file', 'esportare report', 'importare dati',
  ],
  verbs: [],
  phrasePatterns: [
    /\b(sto|stavo)\s+(studiando|lavorando|correndo|camminando|scrivendo)\b/i,
    /\b(sto|stavo)\s+(revisionando|rispondendo|preparando|aggiornando|debuggando)\b/i,
    /\b(studio|sto\s+studiando|ripasso|sto\s+ripassando|imparo|sto\s+imparando)\s+(?!come\s+fare\b)([a-z\u00c0-\u017f][a-z\u00c0-\u017f0-9-]*(\s+[a-z\u00c0-\u017f][a-z\u00c0-\u017f0-9-]*){0,3})\b/i,
    /\b(revisiono|sto\s+revisionando|rispondo|sto\s+rispondendo|preparo|sto\s+preparando|aggiorno|sto\s+aggiornando)\s+(a|il|la|alle|ai)?\s*(email|mail|presentazione|slide|roadmap|report|documento|ticket|codice)\b/i,
    /\b(ho\s+appena\s+)?(fatto|finito)\s+(la\s+)?(riunione|chiamata|spesa|lezione|corsa)\b/i,
    /\b(sto\s+scrivendo|sto\s+lavorando\s+su)\s+(il\s+)?(report|documento|compito|codice)\b/i,
    /\b(ho\s+appena\s+)?(pubblicato|rilasciato|inviato)\s+(una\s+|il\s+)?(correzione|feature|aggiornamento|report|documento)\b/i,
    /\b(sto|stavo)\s+(guidando|prendendo)\s+(la\s+)?(macchina|metro|autobus|treno|taxi)\b/i,
    /\b(sono|sto)\s+(in\s+)?(metro|autobus|treno|macchina|ufficio|palestra|supermercato)\b/i,
    /\b(sto|ho\s+)?(facendo|fatto|finito)\s+(la\s+)?(spesa|lavatrice|pulizie|cena|pranzo|colazione)\b/i,
    /\b(sto|ho\s+)?(lavando|lavato)\s+(i\s+)?piatti\b/i,
    /\b(sto|ho\s+)?(nuotando|nuotato|pedalando|pedalato|camminando|fatto\s+trekking|fatto\s+yoga)\b/i,
    /\b(gioco|sto\s+giocando|ho\s+giocato)\s+(a\s+)?(calcio|basket|tennis|badminton|pallavolo)\b/i,
    /\b(sto|ho\s+)?(guardando|visto)\s+(un\s+)?(film|serie|streaming)\b/i,
    /\b(sto|ho\s+)?(ascoltando|ascoltato)\s+(un\s+)?podcast\b/i,
    /\b(sto|ho\s+)?(uscendo|uscito|incontrando|incontrato)\s+(con\s+)?(amici|famiglia)\b/i,
    /\b(sono\s+andato|vado|sto\s+andando)\s+(al\s+|alla\s+)?(concerto|mostra|museo|bar)\b/i,
    /\b(karaoke|giochi\s+da\s+tavolo|serata\s+giochi)\b/i,
    /\b(chatto|sto\s+chattando|chiacchiero|sto\s+chiacchierando)\s+(con\s+.+)?\b/i,
    /\b(prendo|ho\s+preso|sto\s+prendendo|faccio|ho\s+fatto)\s+(colazione|pranzo|cena)\b/i,
    /\b(guardo|sto\s+guardando|ho\s+guardato)\s+(anime|serie|film|notizie)\b/i,
    /\b(leggo|sto\s+leggendo|ho\s+letto)\s+(manga|romanzo|libro|giornale|articolo|articoli|notizie)\b/i,
    /\b(scrivo|sto\s+scrivendo|ho\s+scritto)\s+(il\s+)?(diario|resoconto|appunti)\b/i,
    /\b(prendo|sto\s+prendendo|ho\s+preso)\s+(appunti|note)\b/i,
    /\b(visita\s+medica|dal\s+dentista|visita\s+dal\s+dentista)\b/i,
    /\b(pago|sto\s+pagando|ho\s+pagato)\s+(le\s+)?(bollette|utenze|affitto)\b/i,
    /\b(videogioco|sto\s+giocando|ho\s+giocato)\b/i,
    /\b(in\s+ufficio|in\s+palestra|a\s+scuola)\b/i,
    /\b(in|alla)\s+riunione\b/i,
    /\b(videochiamata|chiamata)\b/i,
    // Reflexive verbs in passato prossimo (mi sono + participio)
    /\bmi\s+sono\s+(allenato|allenata|svegliato|svegliata|addormentato|addormentata|riposato|riposata|lavato|lavata|vestito|vestita)\b/i,
    // Common short-form activity entries
    /\b(ho\s+fatto\s+(la\s+)?doccia)\b/i,
    /\b(ho\s+fatto\s+(una\s+)?passeggiata)\b/i,
    /\b(ho\s+fatto\s+(una\s+)?corsa)\b/i,
    /\b(ho\s+fatto\s+(una\s+)?videochiamata)\b/i,
    /\b(ho\s+fatto\s+(la\s+)?spesa)\b/i,
    /\b(sono\s+andato|sono\s+andata)\s+(al\s+|alla\s+|in\s+)?(bar|palestra|ufficio|supermercato|medico|dentista|cinema)\b/i,
    /\b(sto\s+aspettando|ho\s+aspettato)\b/i,
    /\b(ho\s+visto)\s+(un\s+)?(film|serie|documentario|video)\b/i,
    /\b(ho\s+ascoltato)\s+(un\s+)?(podcast|musica|canzone|album)\b/i,
    /\b(ho\s+letto)\s+(un\s+)?(libro|articolo|romanzo|manga|fumetto)\b/i,
    /\b(ho\s+giocato)\s+(a\s+)?(calcio|basket|tennis|badminton|videogiochi?|giochi?\s+da\s+tavolo)\b/i,
    // Sport extra
    /\b(ho\s+fatto)\s+(boxe|kickboxing|judo|karate|arti\s+marziali|yoga|pilates|stretching|ginnastica|jogging|footing)\b/i,
    /\b(ho\s+sollevato|sollevo)\s+pesi\b/i,
    /\b(ho\s+fatto)\s+(delle\s+)?(flessioni|addominali|squat|piegamenti)\b/i,
    /\b(faccio|ho\s+fatto)\s+(sport|ginnastica|allenamento)\b/i,
    /\b(ho\s+sciato|ho\s+fatto)\s+sci\b/i,
    /\b(mi\s+sono\s+)?(arrampicato|arrampicata)\b/i,
    /\b(ho\s+ballato|ballo|sto\s+ballando)\b/i,
    /\b(ho\s+suonato|suono|sto\s+suonando)\s+(la\s+|il\s+)?(chitarra|pianoforte|violino|basso|batteria|flauto|strumento)\b/i,
    /\b(ho\s+cantato|canto|sto\s+cantando)\b/i,
    /\b(ho\s+disegnato|disegno|sto\s+disegnando)\b/i,
    /\b(ho\s+dipinto|dipingo|sto\s+dipingendo)\b/i,
    // Travel
    /\b(sono\s+(partito|partita)|parto|sto\s+partendo)\b/i,
    /\b(sono\s+(arrivato|arrivata)|arrivo|sto\s+arrivando)\b/i,
    /\b(sono\s+(tornato|tornata)\s+a\s+casa)\b/i,
    /\b(sto\s+facendo|ho\s+fatto)\s+(le\s+)?valigie\b/i,
    /\b(sono\s+in|vado\s+in)\s+viaggio\b/i,
    // Wellness / appointments
    /\b(ho\s+(fatto|avuto))\s+(una\s+)?(visita|seduta|sessione)\s+(di\s+)?(terapia|fisioterapia|psicologo|psicologa)\b/i,
    /\b(sono\s+andato|sono\s+andata)\s+(dal\s+|dalla\s+)?(psicologo|psicologa|fisioterapista|nutrizionista)\b/i,
    /\b(ho\s+fatto)\s+(il\s+)?(colloquio|tirocinio|stage)\b/i,
    // Volunteering
    /\b(ho\s+fatto|faccio)\s+volontariato\b/i,
  ],
};

/**
 * Verb conjugation data for auto-generating Italian activity verb forms.
 * Generator in liveInputRules.it.ts produces: infinitive, gerundio, participio,
 * present-1sg, "sto + gerundio", "ho + participio".
 *
 * Tuple: [infinitive, group, irregularParticipo?, irregularGerundio?, irregularPresent1sg?]
 * Leave optional fields undefined to use regular form.
 */
export type ItVerbEntry = readonly [
  string,
  'are' | 'ere' | 'ire',
  (string | undefined)?,
  (string | undefined)?,
  (string | undefined)?,
];

export const itActivityVerbData: readonly ItVerbEntry[] = [
  // Eating / drinking
  ['mangiare', 'are'],
  ['cucinare', 'are'],
  ['bere', 'ere', 'bevuto', 'bevendo', 'bevo'],
  // Sleep
  ['dormire', 'ire'],
  // Exercise / movement
  ['correre', 'ere', 'corso'],
  ['camminare', 'are'],
  ['nuotare', 'are'],
  ['pedalare', 'are'],
  ['sciare', 'are'],
  // Work / study
  ['lavorare', 'are'],
  ['studiare', 'are'],
  ['ripassare', 'are'],
  ['rispondere', 'ere', 'risposto'],
  // Reading / writing
  ['leggere', 'ere', 'letto'],
  ['scrivere', 'ere', 'scritto'],
  // Media / social
  ['guardare', 'are'],
  ['ascoltare', 'are'],
  ['chattare', 'are'],
  // Games
  ['giocare', 'are'],
  // Creative
  ['disegnare', 'are'],
  ['dipingere', 'ere', 'dipinto', 'dipingendo'],
  ['fotografare', 'are'],
  ['ballare', 'are'],
  ['cantare', 'are'],
  ['suonare', 'are'],
  // Chores / errands
  ['pulire', 'ire'],
  ['comprare', 'are'],
  ['preparare', 'are'],
  // Wellness
  ['meditare', 'are'],
  // General (irregular)
  ['fare', 'are', 'fatto', 'facendo', 'faccio'],
  ['vedere', 'ere', 'visto'],
  ['uscire', 'ire', 'uscito', undefined, 'esco'],
];

/**
 * Place nouns used for structural go+place activity detection.
 * Kept separate from strongPhrases to avoid redundancy.
 */
export const itPlaceNouns: readonly string[] = [
  'palestra', 'ufficio', 'supermercato', 'bar', 'caffè', 'cinema',
  'museo', 'medico', 'dentista', 'farmacia', 'ospedale', 'stazione',
  'aeroporto', 'università', 'scuola', 'biblioteca', 'ristorante',
  'pizzeria', 'parco', 'piscina', 'spiaggia', 'montagna', 'negozio', 'mercato',
];
